const actions = {
  BLOG_ADD_BEGIN: 'BLOG_ADD_BEGIN',
  BLOG_ADD_SUCCESS: 'BLOG_ADD_SUCCESS',
  BLOG_ADD_ERR: 'BLOG_ADD_ERR',
  
  BLOGS_READ_BEGIN: 'BLOGS_READ_BEGIN',
  BLOGS_READ_SUCCESS: 'BLOGS_READ_SUCCESS',
  BLOGS_READ_ERR: 'BLOGS_READ_ERR',

  BLOG_UPDATE_BEGIN: 'BLOG_UPDATE_BEGIN',
  BLOG_UPDATE_SUCCESS: 'BLOG_UPDATE_SUCCESS',
  BLOG_UPDATE_ERR: 'BLOG_UPDATE_ERR',

  BLOG_DELETE_BEGIN: 'BLOG_DELETE_BEGIN',
  BLOG_DELETE_SUCCESS: 'BLOG_DELETE_SUCCESS',
  BLOG_DELETE_ERR: 'BLOG_DELETE_ERR',

  BLOG_READ_BEGIN: 'BLOG_READ_BEGIN',
  BLOG_READ_SUCCESS: 'BLOG_READ_SUCCESS',
  BLOG_READ_ERR: 'BLOG_READ_ERR',

  BLOG_UPLOAD_BEGIN: 'BLOG_UPLOAD_BEGIN',
  BLOG_UPLOAD_SUCCESS: 'BLOG_UPLOAD_SUCCESS',
  BLOG_UPLOAD_ERR: 'BLOG_UPLOAD_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.BLOGS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.BLOGS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.BLOGS_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.BLOG_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.BLOG_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.BLOG_ADD_ERR,
      err,
    };
  },

  axiosUpdateBegin: () => {
    return {
      type: actions.BLOG_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.BLOG_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.BLOG_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.BLOG_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.BLOG_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.BLOG_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.BLOG_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.BLOG_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.BLOG_READ_ERR,
      err,
    };
  },

  axiosUploadBegin: () => {
    return {
      type: actions.BLOG_UPLOAD_BEGIN,
    };
  },

  axiosUploadSuccess: data => {
    return {
      type: actions.BLOG_UPLOAD_SUCCESS,
      data,
    };
  },

  axiosUploadErr: err => {
    return {
      type: actions.BLOG_UPLOAD_ERR,
      err,
    };
  },

};

export default actions;
